module.exports = __webpack_public_path__ + "static/media/RoundedRect_Secondary@3x.c953d5e9.png";